import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthService } from '../services/auth.service';
import {
  createLoginUrlTree,
  createPendingDeletionUrlTree,
  isUserPendingDeletion,
  resolveFreshAuthUser,
} from './guard-auth.util';
import { isUserEmailVerified } from '../utils/email-verification.util';

export const clientAuthGuard: CanActivateFn = (_route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const loginRedirect = createLoginUrlTree(router, state);

  if (!localStorage.getItem('token')) {
    return loginRedirect;
  }

  return authService.getUserInfo().pipe(
    map((response) => {
      const user = resolveFreshAuthUser(response);
      if (!user) {
        return loginRedirect;
      }
      if (isUserPendingDeletion(user)) {
        return createPendingDeletionUrlTree(router);
      }
      return isUserEmailVerified(user) ? true : loginRedirect;
    }),
    catchError(() => of(loginRedirect)),
  );
};
